<div class="wrapper">
	<!-- (i) button -->
	<header-icon id="headerInformationIcon" class="msi-common-header-button" [msiDropdownTriggerFor]="userInfoUiDropdown">
		<msi-icon [name]="'ic_information'" size="24"></msi-icon>
	</header-icon>

	<!-- Dropdown menu -->
	<msi-dropdown
		class="user-info"
		#userInfoUiDropdown
		xPosition="before"
		(opened)="isOpen = true"
		(closed)="isOpen = false">
		<div class="dropdown-container">
			<!-- Top bar -->
			<mat-toolbar class="msi-text info-dropdown-header">
				<msi-icon [name]="'ic_information'"></msi-icon>
				<div i18n class="information-panel-title">Information Panel</div>
				<button
					id="closeSupportDropdownButton"
					class="msi-btn msi-btn-icon close-dropdown-btn"
					(click)="supportDropdown?.close()">
					<msi-icon name="ic_remove" size="22"></msi-icon>
				</button>
			</mat-toolbar>

			<!-- Side navigation -->
			<div class="user-info-nav">
				<msi-sidenav role="navigation">
					<msi-item
						i18n
						id="myAgencyInfoSidenavItem"
						[selected]="activeSelection === 'myAgencyInfo'"
						(click)="activeSelection = 'myAgencyInfo'">
						My Agency Info
					</msi-item>
					<msi-item
						i18n
						id="helpSidenavItem"
						[selected]="activeSelection === 'help'"
						(click)="activeSelection = 'help'">
						Help
					</msi-item>
					<msi-item
						i18n
						id="whatsNewSidenavItem"
						[selected]="activeSelection === 'new'"
						(click)="activeSelection = 'new'">
						What's New
					</msi-item>
					<msi-item
						i18n
						id="contactUsSidenavItem"
						[selected]="activeSelection === 'contact-us'"
						(click)="activeSelection = 'contact-us'">
						Contact Us
					</msi-item>
					<msi-item
						i18n
						id="agreementsSidenavItem"
						[selected]="activeSelection === 'agreements'"
						(click)="activeSelection = 'agreements'">
						Agreements
					</msi-item>
				</msi-sidenav>
			</div>

			<!-- Active section -->
			<div class="active-content-container">
				<!-- My Agency Info section -->
				@if (activeSelection === 'myAgencyInfo') {
					<div class="active-content my-agency-contents-container">
						<h4 i18n class="my-agency-info-title">My Agency Information</h4>
						<p i18n>If you need to contact Support, please have the information below readily available.</p>

						<!-- My Agency Name and My Agency ID -->
						<div class="msi-flex-col">
							<msi-item
								id="copyAgencyNameItem"
								class="agency-detail-item"
								(mouseenter)="agencyNameTooltipText = copyAgencyNameText"
								(click)="copyAgencyDetail('userInfoAgencyName', true)"
								[msiTooltip]="copyAgencyNameText"
								[showDelay]="250"
								[hideDelay]="250"
								[templateRef]="agencyNameTooltip">
								<div class="msi-flex-row my-agency-content">
									<div class="my-agency-content-field msi-flex-col">
										<div i18n><b>My Agency Name</b></div>
										<div id="userInfoAgencyName">{{ userInfo?.agency?.name }}</div>
									</div>
									<div class="my-agency-copy-btn-container">
										<div class="msi-btn-icon my-agency-copy-btn">
											<msi-icon name="ic_copy"></msi-icon>
										</div>
										<ng-template #agencyNameTooltip> {{ agencyNameTooltipText }} </ng-template>
									</div>
								</div>
							</msi-item>
							<msi-item
								id="copyAgencyIdItem"
								class="agency-detail-item"
								(mouseenter)="agencyIdTooltipText = copyAgencyIdText"
								(click)="copyAgencyDetail('userInfoAgencyId')"
								[msiTooltip]="copyAgencyIdText"
								[showDelay]="250"
								[hideDelay]="250"
								[templateRef]="agencyIdTooltip">
								<div class="msi-flex-row my-agency-content">
									<div class="my-agency-content-field msi-flex-col">
										<div i18n><b>My Agency ID</b></div>
										<div id="userInfoAgencyId">{{ userInfo?.agency?.id }}</div>
									</div>
									<div class="my-agency-copy-btn-container">
										<div class="msi-btn-icon my-agency-copy-btn">
											<msi-icon name="ic_copy"></msi-icon>
										</div>
										<ng-template #agencyIdTooltip> {{ agencyIdTooltipText }} </ng-template>
									</div>
								</div>
							</msi-item>
						</div>
					</div>
				}

				<!-- Help section -->
				@if (activeSelection === 'help') {
					<div class="active-content help-content">
						<!-- Note: Do not remove the "in-app-user-guide-btn" class as Pendo is relying on it -->
						<button i18n id="inAppUserGuideButton" class="msi-btn in-app-user-guide-btn">In-app User Guide</button>
						<p i18n>
							Orchestrate training is available on Motorola Solution's
							<a class="msi-link" href="https://learning.motorolasolutions.com/search?t=orchestrate" target="_blank">
								Learning Experience Portal
							</a>
						</p>

						<p i18n>
							Click
							<a class="msi-link contact-us-pointer" (click)="activeSelection = 'contact-us'">here</a>
							to give your feedback or report a bug.
						</p>

						<p i18n>For help in North America, please contact Motorola Solutions support.</p>
						<p>
							<msi-icon class="help-text-call-icon" name="ic_call" [size]="14"></msi-icon> +1 800-MSI-HELP <br />
							<span i18n class="sub-label">state orchestrate at prompt</span>
						</p>
						<p i18n>
							For help outside North America, local support phone numbers are available via the links below:<br />
							<a class="msi-link" target="_blank" href="https://www.motorolasolutions.com/zh_cn/support.html">
								Chinese
							</a>
							<br />
							<a class="msi-link" target="_blank" href="https://www.motorolasolutions.com/en_xp/support.html">
								English
							</a>
							<br />
							<a class="msi-link" target="_blank" href="https://www.motorolasolutions.com/ja_jp/support.html">
								Japanese
							</a>
							<br />
							<a class="msi-link" target="_blank" href="https://www.motorolasolutions.com/ko_kr/support.html">
								Korean
							</a>
							<br />
							<a class="msi-link" target="_blank" href="https://www.motorolasolutions.com/en_xa/support.html">
								Australia/New Zealand (English)
							</a>
							<br />
							Support is available 9am to 6pm GMT+8 Monday through Friday for Partners in Asia and 9am to 6pm AEDT for
							Partners in Australia and New Zealand
						</p>
						<msi-tag value="var(--ui-version-bg-color)" [filled]="true">{{ uiVersion }}</msi-tag>
					</div>
				}

				<!-- What's New section -->
				@if (activeSelection === 'new') {
					<div class="active-content">
						<table msi-table id="release-notes msi-table-condensed" style="margin: 0 auto">
							<tbody>
								@for (releaseNote of releaseNotes; track releaseNote; let i = $index) {
									<tr>
										<td><msi-icon name="ic_file"></msi-icon></td>
										<td>{{ releaseNote.releaseTitle }}</td>
										<td>
											<button
												i18n="Action to view release notes"
												id="viewReleaseNotesButton-{{ releaseNote.releaseTitle }}"
												class="msi-btn msi-btn-flat"
												(click)="openFeatureDescription(i)">
												Show
											</button>
										</td>
									</tr>
								}
							</tbody>
							@if (!releaseNotes?.length) {
								<div i18n class="nothing-new">Nothing new</div>
							}
						</table>
					</div>
				}

				<!-- Contact Us section -->
				@if (activeSelection === 'contact-us') {
					<div class="active-content">
						<div class="msi-flex-col help-content">
							<h5 i18n>Contact us form</h5>
							<p i18n><small>For urgent issues please contact +1 800-MSI-HELP</small></p>
							<form (ngSubmit)="onSubmit(feedbackForm)" #feedbackForm="ngForm" autocomplete="off">
								<label i18n class="msi-label msi-input-label" for="feedbackType">Type of Feedback*</label>
								<msi-select
									id="feedbackTypeSelect"
									required
									(keydown)="$event.stopPropagation()"
									[(ngModel)]="feedbackType"
									name="feedbackType">
									@for (feedback of feedbackTypes; track feedback) {
										<msi-select-option value="{{ feedback }}">{{ feedback }}</msi-select-option>
									}
								</msi-select>
								<label i18n class="msi-label msi-input-label" for="title">Title*</label>
								<input
									id="feedbackTitleInput"
									msiInput
									class="msi-input"
									type="text"
									id="feedbackTitle"
									width="100%"
									required
									[maxlength]="128"
									(keydown)="$event.stopPropagation()"
									[(ngModel)]="titleString"
									name="feedbackTitle" />
								<label i18n class="msi-label msi-input-label" for="details">Details*</label>
								<textarea
									msiResizableTextarea
									id="feedbackDetail"
									width="100%"
									maxHeight="166"
									minHeight="60"
									required
									[maxlength]="4000"
									class="msi-input"
									(keydown)="$event.stopPropagation()"
									[(ngModel)]="detailsString"
									name="feedbackDetail">
								</textarea>
								<div class="py-2">
									<button
										i18n
										id="submitFeedbackButton"
										type="submit"
										class="msi-btn"
										[disabled]="!feedbackForm.form.valid">
										Submit
									</button>
								</div>
							</form>
						</div>
					</div>
				}

				<!-- Agreements section -->
				@if (activeSelection === 'agreements') {
					<div class="active-content">
						<div class="msi-flex-col help-content">
							<h5 i18n>End user agreements</h5>
							<table msi-table>
								<tbody>
									@for (agreement of agreements; track agreement.id) {
										<tr>
											<td>
												<a [href]="agreement.url | safeUrl" target="_blank">{{ agreement.name }} </a>
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				}
			</div>
		</div>
	</msi-dropdown>
</div>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
